import { ChakraProvider } from '@chakra-ui/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from 'next-themes'

import Auth from '@/components/Auth/Auth'
import { AppErrorBoundary } from '@/components/feedback/AppErrorBoundary'
import { Toaster } from '@/components/feedback/Toaster'
import { queryClient } from '@/lib/queryClient'
import { system } from '@/theme'

/**
 * Provider order matters:
 *  - the error boundary is outermost, so a failure inside Chakra, Query or the
 *    session restore still renders a recoverable screen;
 *  - <Auth> sits inside the providers but outside the router, so the session is
 *    restored once for the whole application before any route mounts.
 */
export const AppProviders = ({ children }) => (
  <AppErrorBoundary>
    <ChakraProvider value={system}>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange={false}
      >
        <QueryClientProvider client={queryClient}>
          <Auth>{children}</Auth>
          <Toaster />
        </QueryClientProvider>
      </ThemeProvider>
    </ChakraProvider>
  </AppErrorBoundary>
)
